import React from 'react';
import Link from 'gatsby-link';

import PageHeader from '../../components/header/page';
import ContentBlock from '../../components/contentblock';
import SidebarNav from '../../components/navigation/sidebar';
import InfoBox from '../../components/navigation/infobox';
import BackgroundImage from '../../resources/images/header/dexa.jpg';

const CtPage = props =>
  (<main>
    <PageHeader headline="CT" image={BackgroundImage}/>
    <section className="container-custom split">
      <div className="custom-container">
        <ContentBlock title="Vorbereitungen zu Hause:">
          <ul className="feature-list">
            <li>
              Die Untersuchungsregion muss frei von Kleidung und Schmuck sein.
            </li>
            <li>
              Bringen Sie Ihre <strong>Vorbefunde</strong> mit (OP-Berichte, Röntgenbilder etc.).
            </li>
          </ul>
        </ContentBlock>
        <ContentBlock title="Vorbereitungen in der Ordination:">
          <ul className="feature-list">
            <li>
              Füllen Sie in der Ordination das <strong>Anamneseblatt</strong> aus.
            </li>
            <li>
              Teilen Sie uns eine <strong>eventuelle Schwangerschaft</strong> unverzüglich mit.
            </li>
            <li>
              Liegen Sie während der Untersuchung ruhig. Sie ist generell von kurzer Dauer, abhängig von der zu untersuchenden Region.
            </li>
            <li>
              Im Bedarfsfall erfolgt eine Aufklärung über <strong>Kontrastmittel</strong>.
              <ul>
                <li>
                Bei CT-Untersuchungen mit Kontrastmittel ist es wichtig, 
                dass Sie uns unverzüglich über eine eventuelle Schilddrüsen- oder Diabeteserkrankung 
                informieren und ob Ihre Nierenwerte im Normbereich sind.
                </li>
              </ul>
            </li>
          </ul>
        </ContentBlock>
        <ContentBlock title="Befundsbesprechung:">
          <ul className="feature-list">
            <li>
              Die <strong>Befundbesprechung</strong> erfolgt beim überweisenden Arzt/Ärztin.
            </li>
          </ul>
        </ContentBlock>
        </div>
        <aside className="sidebar">
          <SidebarNav />
            <InfoBox name="ct" />
        </aside>
    </section>
  </main>);

export default CtPage;


// WEBPACK FOOTER //
// ./src/pages/leistungen/ct.js